import _slicedToArray from "/builds/1TgzPVrG/0/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useState, useEffect } from "react";
import { useSpring, animated as A } from "react-spring";
import * as Icons from "../../../Icons";
import * as S from "./styles";
export var CartControl = function CartControl(_ref) {
  var t = _ref.showIcon,
      e = _ref.addedToCart,
      a = _ref.removedFromCart,
      r = _ref.onAddClick,
      o = _ref.onRemoveClick,
      n = _ref.tabIndex;

  var _useState = useState(!1),
      _useState2 = _slicedToArray(_useState, 2),
      s = _useState2[0],
      c = _useState2[1],
      _useSpring = useSpring(function () {
    return {
      transform: "translateY(20px)",
      opacity: 0
    };
  }),
      _useSpring2 = _slicedToArray(_useSpring, 2),
      l = _useSpring2[0],
      d = _useSpring2[1],
      p = useSpring({
    opacity: t || e ? 1 : 0
  });

  useEffect(function () {
    d.set({
      transform: s ? "translateY(0px)" : "translateY(20px)",
      opacity: s ? 1 : 0
    });
  }, [s, d.set]), useEffect(function () {
    (e || a) && (c(!0), setTimeout(function () {
      c(!1);
    }, 1500));
  }, [e, a]), useEffect(function () {
    s && !t && (d.stop(), d.set({
      opacity: 0,
      transform: "translateY(20px)"
    }));
  }, [t, s, d.stop, d.set]);
  return React.createElement(S.Wrapper, {
    "data-testid": "cartControl"
  }, React.createElement(S.CartStatusAndIcon, null, React.createElement(S.AnimatedText, {
    style: l
  }, e && "Added"), React.createElement(A.div, {
    style: p
  }, React.createElement(S.IconWrapper, {
    tabIndex: n,
    "data-testid": "productCardIcon",
    "aria-label": "Add to Cart",
    onClick: e ? function (t) {
      t.preventDefault(), o();
    } : function (t) {
      t.preventDefault(), r();
    }
  }, e ? React.createElement(Icons.AddedToCart, null) : React.createElement(Icons.AddToCart, null)))));
};
export default CartControl;